import React from "react";
import style from "./Info.module.css";

import ubi from "../../../Assets/ubic.svg";
import face from "../../../Assets/facelogo.png";
import ig from "../../../Assets/iglogo.png";
import lawlogo from "../../../Assets/logoLaw.png";
import mail from "../../../Assets/mail.svg";
import phone from "../../../Assets/phon.png";
import map from "../../../Assets/map.png";
import wsp from "../../../Assets/wlogo.png";

export const Info = () => {
  return (
    <div className={style.container}>
      <div className={style.content}>
        <img src={lawlogo} alt="logo" className={style.logo} />

        <div className={style.infoContent}>
          <img src={ubi} alt="fb" className={style.logoRed} />

          <div className={style.info}>
            <p className={style.textBlue}> Dirección </p>
            <p className={style.textWhite}>7ma. Avenida 5-45, Zona 4, Edificio XPO 1 Of. #301, Guatemala.</p>
          </div>
        </div>

        <div className={style.mapCont}>
          <a target="_blank" href="https://ul.waze.com/ul?place=ChIJjbjdD06jiYURgpGH5FWI2hk&ll=14.61793480%2C-90.51541560&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location">
            <img src={map} alt="map" className={style.map} />
          </a>
        </div>

        <div className={style.infoContent}>
          <img src={phone} alt="tel" className={style.logoRed} />
          <div className={style.info}>
            <p className={style.textBlue}> Teléfono</p>
            <p className={style.textWhite}> +502 3100-5908</p>
          </div>{" "}
        </div>

        <div className={style.infoContent}>
          <img src={mail} alt="mail" className={style.logoRed} />
          <div className={style.info}>
            <p className={style.textBlue}>Correo electrónico </p>
            <p className={style.textWhite}> thelawyersco2021@gmail.com</p>
          </div>{" "}
        </div>

        <div style={{paddingTop:"15px"}}>
          <a href="https://www.facebook.com/thelawyersco/" target="_blank">     
            <img src={face} alt="fb" className={style.logoRed} />
          </a>
          <a href="https://www.instagram.com/thelawyersco/" target="_blank">     
            <img src={ig} alt="ig" className={style.logoRed} />
          </a>
          <a href="https://wa.me/50231005908/" target="_blank" className={style.logoRed}>     
            <img src={wsp} alt="wsp" className={style.logoRed} />
          </a>
        </div>
      </div>
    </div>
  );
};
